const _ = require('lodash')

export async function feed(sport, period, showLive, liveCount, maxMatchesCount, focusedTournament) {
    if(period === 'live' || period === 'focusedTournament' ){
        showLive = true
    }

    const response = await fetch('/api/data/odds', {
        method: 'POST',
        body: JSON.stringify({
            sport,
            period,
            showLive,
            liveCount,
            maxMatchesCount,
            focusedTournament,
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return await response.json();
}

export async function fetchSports(maxMatchesCount) {

    const response = await fetch('/api/data/fetchSports', {
        method: 'POST',
        body: JSON.stringify({
            maxMatchesCount,
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return await response.json();
}

export function sortOdds(odds) {
    let batchesId = _.map(Object.keys(odds), (value) => {
        return parseInt(value)
    })
    let oldBatchId = _.min(batchesId)
    let newBatchId = _.max(batchesId)
    let newSortedOdds = []
    _.forEach(odds[oldBatchId], (value, index) => {
        newSortedOdds.push({old: odds[oldBatchId][index], new: odds[newBatchId][index]})
    })
    return {odds : newSortedOdds, newBatchId}
}

export function formattedKeyLeagueName(leagueName, date) {
    return 'league_view_'+leagueName.replaceAll(' ', '-')+date
}

export function formatOdd(oddsFormatCountry, odd) {
    switch (oddsFormatCountry) {
        case "Hong Kong":
            return formatOddToHongKong(odd)
        case null:
        case "Malay":
            return formatOddToMalay(odd)
        case "Indo":
            return formatOddToIndo(odd)
        case "Decimal":
            return formatOddToDecimal(odd)
    }
}

function formatOddToHongKong(odd) {
    return (parseFloat(formatOddToDecimal(odd))  - 1 ).toFixed(2);
}

function formatOddToMalay(odd) {
    return parseFloat(odd).toFixed(2);
}

function formatOddToIndo(odd) {
    let decimalOdds = parseFloat(formatOddToDecimal(odd))
    if(decimalOdds >= 2){
        return formatOddToHongKong(odd)
    }
    else{
        odd = ((-1)/(decimalOdds -1))
        return parseFloat(odd).toFixed(2);
    }
}

function formatOddToDecimal(odd) {
    odd = parseFloat(odd)
    if(odd < 0){
        odd = (1/(Math.abs(odd)))
    }
    return (odd + 1).toFixed(2);
}